import { Framebuffer } from './framebuffer';
import { Texture, type TextureFilter, type TextureFormat } from './texture';

/** A texture plus the framebuffer that renders into it. */
export class RenderTarget {
  readonly texture: Texture;
  readonly framebuffer: Framebuffer;

  constructor(
    gl: WebGL2RenderingContext,
    width: number,
    height: number,
    format: TextureFormat = 'rgba8',
    filter: TextureFilter = 'linear',
  ) {
    this.texture = Texture.create(gl, width, height, format, filter);
    this.framebuffer = new Framebuffer(gl).attach(this.texture);
  }

  get width(): number {
    return this.texture.width;
  }

  get height(): number {
    return this.texture.height;
  }

  get bytes(): number {
    return this.texture.bytes;
  }

  resize(width: number, height: number): void {
    if (this.texture.width === width && this.texture.height === height) return;
    this.texture.resize(width, height);
    this.framebuffer.attach(this.texture);
  }

  clear(r = 0, g = 0, b = 0, a = 0): void {
    this.framebuffer.clear(r, g, b, a);
  }

  dispose(): void {
    this.framebuffer.dispose();
    this.texture.dispose();
  }
}
